import { CIMSPage } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { RoutingGroup } from '../../../RoutingGroupsTableContext'

export function useExpandOptions(): ExpandOptions<RoutingGroup> {
  return {
    expandable: ({ casToCASRoutingGroups }) => casToCASRoutingGroups.length > 0,
    render: ({ id, casToCASRoutingGroups }) => {
      return {
        additionalInfo: [
          {
            label: 'Associated Submittals',
            help: HelpMessage.CAS.RoutingGroups.AssociatedSubmittals,
            type: 'deepLinks',
            showMore: { key: id },
            links: casToCASRoutingGroups.map(
              ({ submittal: { id, packageNumber, packageName, deleted } }) => ({
                label: packageNumber,
                tooltip: packageName,
                page: CIMSPage.CASTracker,
                deep: { recordId: id, deleted },
              })
            ),
          },
        ],
      }
    },
  }
}
